import { loadPageNotFoundScript } from "../../StaticAssets";
import { TableauLocalizedStrings } from "../../Strings";

export function showMissingViewPage(
  doc: Document,
  strings: TableauLocalizedStrings,
  linksGallery?: string,
  requestString?: string
) {
  const renderer = new MissingViewPageRenderer(
    doc,
    strings,
    linksGallery,
    requestString
  );

  doc.body.replaceChildren(...renderer.topPageElements());

  doc.body.className = "body";

  doc
    .querySelectorAll('style,link[rel="stylesheet"]')
    .forEach((element) => element.remove());

  void loadPageNotFoundScript(doc);
}

class MissingViewPageRenderer {
  doc: Document;
  strings: TableauLocalizedStrings;
  linksGallery?: string;
  requestString?: string;

  constructor(
    doc: Document,
    strings: TableauLocalizedStrings,
    linksGallery?: string,
    requestString?: string
  ) {
    this.doc = doc;
    this.strings = strings;
    this.linksGallery = linksGallery;
    this.requestString = requestString;
  }

  public topPageElements(): HTMLElement[] {
    return [this.heading(), this.errorParagraph(), this.requestIdParagraph()];
  }

  private heading() {
    const heading = this.doc.createElement("h1");
    heading.innerHTML = this.strings.getString("PageNotFoundResourceNotFound");
    return heading;
  }

  private errorParagraph() {
    const errorParagraph = this.doc.createElement("p");
    errorParagraph.innerHTML = this.strings.getString(
      "PageNotFoundPleaseCheckUrlAndTryAgain"
    );
    return errorParagraph;
  }

  private requestIdParagraph() {
    const requestIdParagraph = this.doc.createElement("p");
    requestIdParagraph.id = "requestID";
    return requestIdParagraph;
  }
}
